/**
 * TRV Read More Component JavaScript
 */

window.TrvReadMore = (function() {
  'use strict';

  function isTextTruncated(element) {
    // Check if text is being truncated by comparing scrollHeight with clientHeight
    return element.scrollHeight > element.clientHeight;
  }

  function checkTruncation(id) {
    const textElement = document.getElementById(`read-more-text-${id}`);
    const buttonElement = document.getElementById(`read-more-button-${id}`);
    
    if (!textElement || !buttonElement) {
      return;
    }

    // Only show button if text is truncated
    if (isTextTruncated(textElement)) {
      buttonElement.style.display = 'inline-block';
    } else {
      buttonElement.style.display = 'none';
    }
  }

  function toggle(id) {
    const textElement = document.getElementById(`read-more-text-${id}`);
    const buttonElement = document.getElementById(`read-more-button-${id}`);
    
    if (!textElement || !buttonElement) {
      console.warn(`TrvReadMore: Elements not found for ID: ${id}`);
      return;
    }
    
    const originalText = buttonElement.getAttribute('data-original-text');
    const collapseText = buttonElement.getAttribute('data-collapse-text');
    
    if (textElement.classList.contains('expanded')) {
      textElement.classList.remove('expanded');
      buttonElement.textContent = originalText;
    } else {
      textElement.classList.add('expanded');
      buttonElement.textContent = collapseText;
    }
  }

  function init() {
    // Initialize any read-more components on page load
    const buttons = document.querySelectorAll('[id^="read-more-button-"]');
    buttons.forEach(button => {
      if (!button.getAttribute('data-original-text')) {
        button.setAttribute('data-original-text', button.textContent);
      }
      
      // Extract ID from button ID (remove "read-more-button-" prefix)
      const id = button.id.replace('read-more-button-', '');
      checkTruncation(id);
    });

    // Recheck on window resize
    window.addEventListener('resize', function() {
      buttons.forEach(button => {
        const id = button.id.replace('read-more-button-', '');
        const textElement = document.getElementById(`read-more-text-${id}`);
        if (textElement && !textElement.classList.contains('expanded')) {
          checkTruncation(id);
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API
  return {
    toggle: toggle,
    init: init,
    checkTruncation: checkTruncation
  };
})();